module.exports = __webpack_public_path__ + "img/carrouselfeed-placeholder.ccacd917.jpg";